import { NavLink } from 'react-router-dom';

const Logo = ({ onClick =()=>{}, small=false, dwf = false }) => {
    return <NavLink className={`logo_box${dwf || small ? ' sm' : ''}`} to="/" onClick={()=>onClick}><img src={`/assets/logo${small ? '_small' : ''}.png`} alt="Yaarikut" /></NavLink>
};

export default Logo;
